import { Box, Heading,Tabs, TabList, TabPanels, Tab, TabPanel, Text, Flex, Input, Divider, Button } from '@chakra-ui/react'
import React, { Fragment, useContext } from 'react'
import { useState } from 'react'
import SelectedDates from '../component/SelectedDates'
import { Context } from '../component/store'
const Settings = () => {
    const { userData } = useContext(Context)
    const user = userData
    const [firstName, setFirstName] = useState(user.firstName || "")
    const [lastName, setLastName] = useState(user.lastName || "")
    const [email, setEmail] = useState(user.email || "")
    console.log('user : ------', user)
  return (
    <Fragment>
        <Box p={5} flex="1" w={'100%'}>
            <Heading mb={4} ml={4}>{'Settings'}</Heading>

            <Tabs>
            <TabList ml={4}>
                <Tab pl={0} fontSize={'18px'} fontWeight={'semibold'} pb={1} >Profile</Tab>
                {/* <Tab pb={1} fontSize={'18px'}  fontWeight={'semibold'}>Notifications</Tab> */}
                <Tab pb={1} fontSize={'18px'}  fontWeight={'semibold'}>Order Management</Tab>
            </TabList>

            <TabPanels>
                {/* Profile Panel */}
                <TabPanel pr={0}>
                    <Text fontSize={'22px'} fontWeight={'semibold'}>Personal Info</Text>
                    <Flex w={'60%'} justifyContent={'space-between'} alignItems={'center'}>
                        <Box flexBasis={'30%'} >
                        <Text fontSize={'17px'} fontWeight={'semibold'} mt={4}>Full Name</Text>
                        </Box>
                        <Flex flexBasis={'70%'}>
                        <Box flexBasis={'50%'}>
                            <Text fontWeight={'semibold'}>First name</Text>
                            <Input value={firstName} onChange={(e) => setFirstName(e.target.value)} bgColor={'white'} shadow={'md'} rounded={'sm'}/>
                        </Box>
                        <Box ml={6} flexBasis={'50%'}>
                            <Text fontWeight={'semibold'}>Last name</Text>
                            <Input  value={lastName} onChange={(e) => setLastName(e.target.value)} bgColor={'white'} shadow={'md'} rounded={'sm'}/>
                        </Box>
                        </Flex>
                    </Flex>
                    <Divider my={6} border={'1px'} borderColor={'rgba(0, 0, 0, 0.15)'}/>

                    <Flex w={'60%'} justifyContent={'space-between'} alignItems={'center'}>
                        <Box flexBasis={'30%'} >
                        <Text fontSize={'17px'} fontWeight={'semibold'} >Email Address</Text>
                        </Box>
                        <Flex flexBasis={'70%'}>
                            <Input value={email} onChange={(e) => setEmail(e.target.value)} bgColor={'white'} shadow={'md'} rounded={'sm'}/>
                        </Flex>
                    </Flex>

                    <Flex w={'60%'} justifyContent={'flex-end'} my={8}>
                    <Box>
                        <Button bgColor={'white'} mr={4} size={'sm'} px={6} shadow={'md'} rounded={'sm'}>Cancel</Button>
                        <Button colorScheme='twitter' size={'sm'} px={6} shadow={'md'} rounded={'sm'}>Save</Button>
                    </Box>
                    </Flex>
                </TabPanel>
                {/* Notification Panel */}
                {/* <TabPanel pr={0}>
                    <Flex alignItems={'center'}>
                        <Text fontWeight={"semibold"} fontSize={'lg'} mr={3}>OTP Notification</Text>
                        <Switch
                        id={`id`}
                        size="md"
                        isChecked={false}
                        onChange={''}
                        /> 
                    </Flex>                              
                </TabPanel> */}
                {/* Order Management Panel */}
                <TabPanel pr={0}>
                    <SelectedDates/>
                </TabPanel>
            </TabPanels>
            </Tabs>
        </Box>
    </Fragment>
  )
}

export default Settings